/**
 * @module store/tasks/getters
 */

export const tasks = (state) => state.tasks;
export const totalTasksCount = (state) => state.totalTasksCount;
export const incompleteTasksCount = (state) => state.incompleteTasksCount;
export const openTasksCount = (state) => state.openTasksCount;
